import { createTracker, EventTypes } from 'redux-segment';
import { getCurrentUserId } from 'selectors';
import { DEFAULT_PROPERTIES as ANALYTICS_PROPERTIES } from 'analytics/constants';
import getPortalTaskFromPath from 'analytics/helpers';
import { TRACK_SEGMENT_EVENT } from '../actions/actionTypes';

const trackEvent = () => next => (action) => {
  const { type } = action;
  switch (type) {
    case TRACK_SEGMENT_EVENT: {
      // make a segment track call
      const { meta, payload } = action;
      const segmentMeta = {
        analytics: [{
          eventType: EventTypes.track,
          eventPayload: {
            ...payload
          }
        }]
      };
      const trackedAction = {
        ...action,
        meta: {
          ...meta,
          ...segmentMeta
        }
      };
      return next(trackedAction);
    }
    default:
      return next(action);
  }
};

const defaultMapper = {
  skipDefaultMapping: true,
  mapper: {
    '@@router/INIT_PATH': EventTypes.page,
    '@@router/UPDATE_PATH': EventTypes.page,
    '@@router/LOCATION_CHANGE': (getState, { payload }) => {
      const state = getState();
      const { pathname } = payload.location;
      const currentUserId = getCurrentUserId(state);
      const portalTask = getPortalTaskFromPath(pathname);
      return {
        eventType: EventTypes.page,
        eventPayload: {
          properties: {
            [ANALYTICS_PROPERTIES.PORTAL_TASK]: portalTask,
            [ANALYTICS_PROPERTIES.USER_ID]: currentUserId,
            [ANALYTICS_PROPERTIES.SUGGESTED_VALUES]: null,
            [ANALYTICS_PROPERTIES.WHAMMY_ID]: null
          }
        }
      };
    },
    '@@reduxReactRouter/initRoutes': EventTypes.page,
    '@@reduxReactRouter/routerDidChange': EventTypes.page,
    '@@reduxReactRouter/replaceRoutes': EventTypes.page
  }
};

export default [trackEvent, createTracker(defaultMapper)];
